class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  async open(triggeredBy) {
    await this.initUpsell();
    this.openDrawer(triggeredBy);
  }

  async initUpsell(triggeredBy) {
    let upSellContainer = document.querySelector('.product-upsell');
    if (!upSellContainer) return false;
    if (window.DACUpsellTest) {
      window.DACUpsellTest.resolve();
      window.DACUpsellTest.reportImpression();
    }
    if (document.querySelector('#product-upsell__collection')) {
      upsellSliderFlickity = new Flickity('#product-upsell__collection', {
        cellAlign: 'left',
        pageDots: true,
        prevNextButtons: true,
      });
      this.openDrawer(triggeredBy);
    } else if (document.querySelector('#product-upsell__cart') || document.querySelector('#product-upsell__product')) {
      this.openDrawer(triggeredBy);
    } else if (document.querySelector('#product-upsell__recommendations').classList.contains('slide-done')) {
      this.openDrawer(triggeredBy);
    } else {
      let upsellSlider = document.querySelector('#product-upsell__recommendations');
      upsellSlider.innerHTML = '';

      let recommendProdId = document.querySelectorAll('cart-drawer-items .cart-item')[0].getAttribute('data-id');

      fetch(
        window.Shopify.routes.root +
          `recommendations/products?product_id=${recommendProdId}&limit=4&section_id=upsell-recommendations`,
      )
        .then((response) => response.text())
        .then((data) => {
          upsellSlider.innerHTML = data;
          const newUpsellItem = document.querySelectorAll('#shopify-section-upsell-recommendations .grid__item');
          if (newUpsellItem.length > 0) {
            upSellContainer.classList.remove('hidden');
            upsellSliderFlickity = new Flickity('#shopify-section-upsell-recommendations', {
              cellAlign: 'left',
              pageDots: true,
              prevNextButtons: true,
            });
          } else {
            upSellContainer.classList.add('hidden');
          }
        })
        .finally(() => {
          upsellSlider.classList.add('slide-done');
        });
    }
  }

  openDrawer(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    const isCartPage = document.body.classList.contains('template-cart');
    if (!isCartPage)
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    if (!isCartPage) document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      dacBundleManager.init();
    });
  }

  renderContentsDrawer() {
    if (window.location.pathname == '/cart') {
      location.reload();
    }

    let self = this;
    fetch('/cart?view=drawer&timestamp=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET',
    })
      .then(function (content) {
        content.text().then(function (html) {
          document.querySelector('.js-cart-drawer-content').innerHTML = html;
          if (window.DACUpsellTest) {
            window.DACUpsellTest.resolve();
            /* Only report if the drawer is open - a re-render behind a closed drawer is not a view. */
            if (self.classList.contains('active')) window.DACUpsellTest.reportImpression();
          }

          let countCount = parseInt(document.querySelector('.js-data-cart-count').getAttribute('data-count'), 10);
          document.querySelector('.js-cart-count-bubble .header-cart-count-bubble').innerHTML = countCount;
          if (countCount == 0) {
            document.querySelector('.js-cart-count-bubble').classList.add('hide');
            self.classList.add('is-empty');
          } else {
            document.querySelector('.js-cart-count-bubble').classList.remove('hide');
            self.classList.remove('is-empty');
          }

          self.initUpsell();
          dacBundleManager.init();
        });
      })
      .finally(() => {
        setTimeout(() => {
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
          this.open();
        });
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class RecommendationsAdd extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.submitButton = this;
    if (this.submitButton.classList.contains('disabled')) return;

    this.submitButton.classList.add('loading');

    let properties = {};
    if (this.getAttribute('data-offer')) {
      properties = { _Offer: this.getAttribute('data-offer') };
    }
    if (this.getAttribute('data-gift')) {
      properties = { _Gift: this.getAttribute('data-gift') };
    }
    let selling_plan = '';
    if (this.getAttribute('data-selling-plan')) {
      selling_plan = this.getAttribute('data-selling-plan');
    }

    /* Split-test arm that produced this add. Reported to GA4 only - deliberately not added to
       the line item, because line item properties reach ShipStation as item options and slow
       warehouse processing. See cart-upsell-test.js.

       Only counted when the arm was shown as one of two or more, matching the impression event.
       Without this the leftover arm - the one rendered alone after its rival was added - would
       contribute adds with no matching impression and overstate the add rate. */
    const upsellArm = this.getAttribute('data-upsell-arm');
    const upsellCard = this.closest('[data-upsell-arm-count]');
    const upsellArmCount = upsellCard ? parseInt(upsellCard.getAttribute('data-upsell-arm-count'), 10) : 0;
    const upsellInTest = Boolean(upsellArm) && upsellArmCount > 1;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: this.getAttribute('data-id'),
            quantity: 1,
            properties: properties,
            selling_plan: selling_plan,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (upsellInTest && window.DACUpsellTest) {
          window.DACUpsellTest.track('dac_upsell_add', {
            upsell_arm: upsellArm,
            upsell_arm_count: upsellArmCount,
            upsell_variant_id: this.getAttribute('data-id'),
            upsell_product_title: upsellCard.getAttribute('data-upsell-product-title') || '',
            upsell_value: parseFloat(upsellCard.getAttribute('data-upsell-value')) || 0,
            upsell_currency: upsellCard.getAttribute('data-upsell-currency') || '',
          });
        }
        this.cart.renderContentsDrawer();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }
}

customElements.define('recommendations-add', RecommendationsAdd);

class RecommendationsShowAdd extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.wrap = this.closest('.product-recommendation');
    this.addProduct = this.wrap.querySelector('.product-form-wrap');
    this.infoProduct = this.wrap.querySelector('.product-info-wrap');
    this.titleProduct = this.wrap.querySelector('.cart-item__name');

    this.addProduct.classList.remove('hidden');
    this.infoProduct.classList.add('hidden');
    this.titleProduct.classList.add('hidden');

    setTimeout(() => {
      upsellSliderFlickity.resize();
    }, 100);
  }
}

customElements.define('recommendations-show', RecommendationsShowAdd);

/**
 * Bundle Manager - Remove and Update Bundle Quantities in Cart
 * Using Cart Line Item Key: https://stackoverflow.com/questions/60616697/shopify-remove-change-quantity-of-multiple-cart-items/60622488#60622488
 */
dacBundleManager = {
  init: function init() {
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Initialize remove bundle buttons
    const removeButtons = document.querySelectorAll('[data-dac-delete-bundle]');
    for (var i = 0; i < removeButtons.length; i++) {
      removeButtons[i].addEventListener('click', function (e) {
        e.preventDefault();
        const bundleID = this.getAttribute('data-dac-bundle');
        const line = this.getAttribute('data-line-item-key');
        dacBundleManager.removeBundle(bundleID, line);
        e.stopPropagation();
      });
    }

    // Initialize bundle quantity inputs
    const bundleInputs = document.querySelectorAll('.is-bundle .quantity__input');
    for (var j = 0; j < bundleInputs.length; j++) {
      bundleInputs[j].addEventListener('change', function (e) {
        const newQuantity = parseInt(this.value);
        const bundleOffer = this.closest('.is-bundle').getAttribute('data-bundle-offer');
        const line = this.getAttribute('data-index');

        if (bundleOffer && newQuantity >= 0) {
          dacBundleManager.updateBundleQuantity(bundleOffer, newQuantity, line);
        }
      });
    }

    // Initialize bundle quantity buttons (plus/minus)
    const bundleButtons = document.querySelectorAll('.is-bundle .quantity__button');
    for (var k = 0; k < bundleButtons.length; k++) {
      bundleButtons[k].addEventListener('click', function (e) {
        e.preventDefault();

        const input = this.parentElement.querySelector('.quantity__input');
        const currentQty = parseInt(input.value);
        const step = parseInt(input.getAttribute('step')) || 1;
        const min = parseInt(input.getAttribute('min')) || 0;
        const max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : Infinity;

        let newQty = currentQty;

        if (this.getAttribute('name') === 'plus') {
          newQty = Math.min(currentQty + step, max);
        } else if (this.getAttribute('name') === 'minus') {
          newQty = Math.max(currentQty - step, min);
        }

        if (newQty !== currentQty) {
          const bundleOffer = this.closest('.is-bundle').getAttribute('data-bundle-offer');
          const line = input.getAttribute('data-index');

          if (bundleOffer) {
            dacBundleManager.updateBundleQuantity(bundleOffer, newQty, line);
          }
        }

        e.stopPropagation();
      });
    }
  },

  removeBundle: function removeBundle(bundleID, line) {
    // Show loading overlays
    const cartItemElements = this.cart.querySelectorAll(`[id="CartItem-${line}"] .loading-overlay`);
    const cartDrawerItemElements = this.cart.querySelectorAll(`[id="CartDrawer-Item-${line}"] .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    // Build updates object for all bundle items
    const updates = {};
    const bundleLines = document.querySelectorAll('[data-dac-bundle="' + bundleID + '"]');

    for (var i = 0; i < bundleLines.length; ++i) {
      const key = bundleLines[i].getAttribute('data-cart-item-key');
      updates[key] = 0;
    }

    // Use /cart/update.js endpoint (note the .js extension)
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Cart update failed');
        }
        return response.json();
      })
      .then((cart) => {
        // Cart is updated, now refresh the UI
        this.cart.renderContentsDrawer();
      })
      .catch((error) => {
        console.error('Error removing bundle:', error);
        // Still try to refresh to show current state
        this.cart.renderContentsDrawer();
      });
  },

  updateBundleQuantity: function updateBundleQuantity(bundleOffer, quantity, line) {
    // Show loading overlays for all items in this bundle
    const bundleItems = document.querySelectorAll('[data-bundle-offer="' + bundleOffer + '"]');
    const overlays = [];

    bundleItems.forEach((item) => {
      const itemKey = item.getAttribute('data-cart-item-key');
      const cartItemOverlay = this.cart.querySelectorAll(`[data-cart-item-key="${itemKey}"] .loading-overlay`);
      overlays.push(...cartItemOverlay);
    });

    overlays.forEach((overlay) => overlay.classList.remove('hidden'));

    // Build update object for all items in bundle
    const updates = {};
    bundleItems.forEach((item) => {
      const cartItemKey = item.getAttribute('data-cart-item-key');
      if (cartItemKey) {
        updates[cartItemKey] = quantity;
      }
    });

    if (Object.keys(updates).length > 0) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates: updates }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Cart update failed');
          }
          return response.json();
        })
        .then((cart) => {
          this.cart.renderContentsDrawer();
        })
        .catch((error) => {
          console.error('Error updating bundle:', error);
          this.cart.renderContentsDrawer();
        });
    }
  },
};

dacBundleManager.init();
